import _ from 'underscore';

export { parseEditScheduledImportOptions } from './edit-import-parser';
export { parseModelToImportUserPreferences } from './form-model-parser';
export { parseModelToImportUserPreference } from './form-model-json-parser';
export { parseJsonFormatImportOptions } from './json-option-parser';
export { parseExistingImportOptions } from './previous-options-parser';

export function pickModelPropertiesByFields(model, fields) {
  const plucked = _.pick(model, (value, key) => (
    _.contains(_.pluck(fields, 'property'), key)
  ));

  return plucked;
}
